export function areDependenciesValid({
  depends_on,
  question_order,
  questions,
}) {
  return (
    depends_on === null ||
    depends_on === undefined ||
    (Array.isArray(depends_on) &&
      depends_on.every(depend => {
        let dependency_order =
          questions.find(question =>
            [question.id, question.resource_id].includes(depend.id)
          )?.order || -1

        return (
          !!depend.id &&
          !!depend.validation &&
          dependency_order < question_order &&
          depend.value !== undefined &&
          depend.value !== null &&
          !!depend.value.toString().trim().length
        )
      }))
  )
}
